(function($) {
    $.fn.isWelshPage = function() {
        return $('html').is(':lang(cy-GB)');
    };
}(jQuery));
